// Generated by scripts/update-seeq-icons.js from src/svg/seeq/short-dash-dot-dot.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcShortDashDotDot = {
  prefix: 'fak',
  iconName: 'short-dash-dot-dot' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f904',
    'M757.8 465.9h87v46.1h-87v-46.1zM757.8 512h87v46.1h-87v-46.1zM931.8 512h82v46.1h-82v-46.1zM363.5 465.9h307.2v46.1h-307.2v-46.1zM184.3 512h87.1v46.1h-87.1v-46.1zM184.3 465.9h87.1v46.1h-87.1v-46.1zM363.5 512h307.2v46.1h-307.2v-46.1zM10.2 512h87.1v46.1h-87.1v-46.1zM10.2 465.9h87.1v46.1h-87.1v-46.1zM931.8 465.9h82v46.1h-82v-46.1z',
  ],
} satisfies IconDefinition;
